import {
    DownOutlined,
    IdcardOutlined,
} from '@ant-design/icons';
import { Form } from 'antd';
import TextArea from 'antd/es/input/TextArea';
import { Select } from 'components';
import { FormSectionsSeparator } from 'features/users/components/modals/form-sections-separator';
import { useTranslation } from 'react-i18next';

import { MarketingCodeFormField } from './types';

export const AddMarketingCodeForm = () => {
    const { t } = useTranslation();

    const provider = [
        { value: "facebook", label: 'FaceBook' },
        { value: "instagram", label: 'instagram' },
        { value: "google", label: 'Google' },
        { value: "twitter", label: 'Twitter' },
    ];;




    return (
        <FormSectionsSeparator title={""}>

            <Form.Item<MarketingCodeFormField>
                label={"Select Provider"}
                name={MarketingCodeFormField.Provider}
                rules={[
                    {
                        required: true,
                        message: t('validateMessages.custom.nomsg'),
                    },
                ]}
            >
                <Select
                    options={provider}
                    placeholder={"Select Registration"}
                    className='has-prefix-icon'
                    suffixIcon={
                        <>
                            <IdcardOutlined className='prefix-icon' />
                            <DownOutlined className='suffix-icon' />
                        </>
                    }
                />
            </Form.Item>

            <Form.Item<MarketingCodeFormField>
                label={"Header Code"}
                name={MarketingCodeFormField.HeaderCode}
                rules={[
                    {
                        required: true,
                        whitespace: true,
                    },
                ]}
            >
                <TextArea
                    placeholder={"Enter Header Code"}
                />
            </Form.Item>

            <Form.Item<MarketingCodeFormField>
                label={"Body Code"}
                name={MarketingCodeFormField.BodyCode}
                rules={[
                    {
                        required: true,
                        whitespace: true,
                    },
                ]}
            >
                <TextArea
                    placeholder={"Enter Body Code"}
                />
            </Form.Item>

            <Form.Item<MarketingCodeFormField>
                label={"Invoice  Code"}
                name={MarketingCodeFormField.InvoiceCode}
                rules={[
                    {
                        required: true,
                        whitespace: true,
                    },
                ]}
            >
                <TextArea
                    placeholder={"Enter Invoice  Code"}
                />
            </Form.Item>

        </FormSectionsSeparator>
    );
};
